import React, { useEffect, useState } from "react";
import { oauthService } from "../services/oauth";

export default function SessionGate({ children }) {
  const [ready, setReady] = useState(oauthService.isAuthenticated());

  useEffect(() => {
    let cancelled = false;
    oauthService.restoreSession().finally(() => {
      if (!cancelled) setReady(true);
    });
    return () => {
      cancelled = true;
    };
  }, []);

  if (!ready) {
    return (
      <div className="flex items-center justify-center min-h-screen" role="status">
        Loading...
      </div>
    );
  }

  return children;
}
